import { Headers } from '@egw/components'
import { SavingsActivityPage } from '@egw/features-transactions'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'
import { useParams } from 'react-router'

export const SavingsAccountActivityPage: FC = () => {
  const { t } = useTranslation()
  const { alias } = useParams<{ alias: string }>()
  return alias ? (
    <Layout>
      <Headers title={t('pages.savings.title')} />
      <SavingsActivityPage alias={parseInt(alias)} />
    </Layout>
  ) : null
}
